<template>
  <div class="g-wrapper">
    <div class="g-main-wrapper">
      <ElTabs v-model="currentRoute" @tab-click="changeRouter">
        <slot></slot>
      </ElTabs>
      <keep-alive :max="10">
        <router-view :key="$route.path" />
      </keep-alive>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentRoute: this.$route.name
    }
  },
  watch: {
    $route() {
      this.currentRoute = this.$route.name
    }
  },

  methods: {
    changeRouter() {
      this.$router.push({ name: this.currentRoute })
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-tabs {
  .el-tabs__header {
    margin-bottom: 10px;
  }
}
</style>
